import React from 'react';
import {Change} from "../Change";

const BuildMissingCompetitors = ({
                                     setPrimaryAndSecondaryVehicles,
                                     vehicleData,
                                     setVehicleData,
                                     openModal,
                                     setOpenModal,
                                     handleModalClose,
                                     secondaryYear,
                                     vehiclesMakes,
                                     vehicleModel,
                                     trimModel,
                                     setTrimModel,
                                     setVehicleModel,
                                     setVehicleMake,
                                     vehiclesTrim,
                                     vehicleIndex,
                                     vehicleTypeName,
                                     driveType,
                                     setDriveType,
                                     isLocked,
                                     handleReload,
                                     changeHandler,
                                     t,
                                     hideButtons,
                                     headerLoadType
                                 }) => {
    return (
        [...Array(4 - setPrimaryAndSecondaryVehicles.length)].map((_, i) => (
            <div className="competitor-vehicle" key={`no-vehicle-selected-${i}`}>
                <div className="competitor-vehicle-overview">
                    <div className="no-vehicle">{t('overview.noVehicleSelected')}</div>
                </div>
                <div className={`no-vehicle-selected${hideButtons ? ' buttons-hidden' : ''}${headerLoadType === 'jdpa' ? ' jdpa-bottom' : ''}`}>
                    <button
                        id={setPrimaryAndSecondaryVehicles.length}
                        className={`btn-default btn-change-compare ${(!setPrimaryAndSecondaryVehicles[0] ||
                            setPrimaryAndSecondaryVehicles[0].length === 0) ? ' disabled is-disabled' : ''}`}
                        value=""
                        onClick={(event) => {
                            if (!setPrimaryAndSecondaryVehicles[0] || setPrimaryAndSecondaryVehicles[0].length === 0) {
                                event.preventDefault();
                                return;
                            }
                            changeHandler(setPrimaryAndSecondaryVehicles.length, "");
                        }}
                    >
                       {t('overview.controls.selectVehicle')}
                    </button>
                    <Change
                        vehicleData={vehicleData}
                        setVehicleData={setVehicleData}
                        openModal={openModal}
                        setOpenModal={setOpenModal}
                        handleModalClose={handleModalClose}
                        years={secondaryYear}
                        vehicleMake={vehiclesMakes}
                        vehicleModels={vehicleModel}
                        trimModel={trimModel}
                        setTrimModel={setTrimModel}
                        setVehicleModel={setVehicleModel}
                        setVehicleMake={setVehicleMake}
                        vehiclesTrim={vehiclesTrim}
                        vehicleIndex={vehicleIndex}
                        vehicleTypeName={vehicleTypeName}
                        driveType={driveType}
                        setDriveType={setDriveType}
                        lockedVehicle={isLocked}
                        onReload={handleReload}
                    />
                </div>
            </div>
        ))
    );
};

export default BuildMissingCompetitors;
